module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag21_1044AT.7b3eb9b2.jpg";